module.exports = __webpack_public_path__ + "img/icon_small-arrow.3877c1d3.svg";